import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { colors } from '../../../theme';

interface ToggleOptionProps<T> {
  value: T;
  label: string;
  isSelected: boolean;
  onClick: () => void;
  disabled?: boolean;
  tooltipText?: string;
}

export function ToggleOption<T>({
  value,
  label,
  isSelected,
  onClick,
  disabled = false,
  tooltipText,
}: ToggleOptionProps<T>) {

  const button = (
    <Box
      component="button"
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      sx={{
        padding: '12px 24px',
        borderRadius: '8px',
        border: `1px solid ${disabled ? colors.slate[200] : isSelected ? colors.signalOrange : colors.slate[200]}`,
        backgroundColor: disabled ? colors.slate[100] : isSelected ? colors.signalOrangeLight : colors.softWhite,
        color: disabled ? colors.slate[400] : isSelected ? colors.signalOrange : colors.slate[600],
        fontWeight: 500,
        fontSize: '0.875rem',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.15s ease',
        opacity: disabled ? 0.6 : 1,
        '&:hover': {
          backgroundColor: disabled ? colors.slate[100] : isSelected ? colors.signalOrangeLight : colors.slate[100],
        },
      }}
    >
      {label}
    </Box>
  );

  if (tooltipText) {
    return (
      <Tooltip title={tooltipText} arrow>
        {button}
      </Tooltip>
    );
  }

  return button;
}
